import { useEffect, useMemo, useRef, useState } from "react";
import client from "../api/client";

const buildQuery = ({ mode }) => {
  const params = new URLSearchParams();
  if (mode) params.set("mode", mode);
  const qs = params.toString();
  return qs ? `?${qs}` : "";
};

export function useLocationSearchDefaults({ mode = "all", enabled = true } = {}) {
  const [state, setState] = useState({
    status: "idle",
    sections: [],
    error: null,
  });
  const latestRef = useRef(0);

  const key = useMemo(
    () => JSON.stringify({ mode, enabled }),
    [mode, enabled],
  );

  useEffect(() => {
    if (!enabled) {
      setState((prev) => ({ ...prev, status: "idle", error: null }));
      return;
    }

    const now = Date.now();
    latestRef.current = now;
    setState((prev) => ({
      status: "loading",
      sections: Array.isArray(prev.sections) ? prev.sections : [],
      error: null,
    }));

    const controller = new AbortController();
    const requestId = latestRef.current;
    client
      .get(`/places/search-defaults${buildQuery({ mode })}`, {
        signal: controller.signal,
      })
      .then((payload) => {
        if (latestRef.current !== requestId) return;
        setState({ status: "success", sections: payload?.sections || [], error: null });
      })
      .catch((error) => {
        if (controller.signal.aborted) return;
        if (latestRef.current !== requestId) return;
        setState({ status: "error", sections: [], error });
      });

    return () => {
      controller.abort();
    };
  }, [key, mode, enabled]);

  return {
    sections: state.sections,
    status: state.status,
    error: state.error,
    isLoading: state.status === "loading",
  };
}
